import * as React from "react";
import {useTheme} from "@mui/material/styles";
import {GridRowModes, DataGrid} from "@mui/x-data-grid";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import {AppBar, Card, Tooltip} from "@mui/material";
import MDBox from "components/MDBox";
import AssignmentIcon from "@mui/icons-material/Assignment";
import {GET} from "APIclient";
import {useNavigate} from "react-router-dom";
import properties from "constants/ApplicationConstants";
import {formatDesignation} from "constants/ApplicationConstants";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import MDTypography from "components/MDTypography";
import {formatDate} from "constants/ApplicationConstants";

export default function ReportingEmployeesList() {
  const theme = useTheme();
  const managerId = Number(window.sessionStorage.getItem("empId"));
  const navigate = useNavigate();
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(20);
  const [totalRows, setTotalRows] = React.useState(0);
  const [paginationModel, setPaginationModel] = React.useState({page: 0, pageSize: 20});
  const [rowModesModel, setRowModesModel] = React.useState({});

  const [snackOpen, setSnackOpen] = React.useState(false);
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackColor, setSnackColor] = React.useState("success");
  const handleClose = () => {
    setSnackOpen(false);
  };

  const fetchData = async (page, pageSize) => {
    try {
      setLoading(true);
      const url = `manager/reporting-employee-details?managerId=${managerId}&page=${page}&size=${pageSize}`;
      const response = await GET(url);
      if (response?.status === 200) {
        const data = response?.data?.data?.paginatedData || [];
        const totalRecords = response?.data?.data?.totalItems || 0;

        const formattedData = data.map((item, index) => ({
          id: page * pageSize + index + 1,
          empId: item?.empId,
          employeeName: item?.employeeName,
          reportingFrom: item?.reportingFrom,
          designation: formatDesignation(item?.designation),
          joinDate: item?.joinDate,
          plannedLeaves: item?.plannedLeaves,
          unplannedLeaves: item?.unplannedLeaves,
          coffLeaves: item?.coffLeaves
        }));

        setData(formattedData);
        setTotalRows(totalRecords);
      } else {
        if (response?.status === 204) {
          setData([]);
          setTotalRows(0);
          //   setSnackMessage("No reporting employees found");
          //   setSnackColor("warning");
          //   setSnackOpen(true);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRows(0);
      setSnackMessage(error.response?.data?.message || "Error fetching employee reporting list.");
      setSnackColor("error");
      setSnackOpen(true);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchData(page, pageSize);
  }, [page, pageSize]);

  const handlePaginationChange = paginationModel => {
    const newPage = paginationModel.page;
    const newPageSize = paginationModel.pageSize;
    setPage(newPage);
    setPageSize(newPageSize);
    setPaginationModel(paginationModel);
     setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  };

  const handleAssignProject = empId => () => {
    navigate(`/assignProject`, {state: empId});
  };

  //   const formatDate = dateString => {
  //     const date = new Date(dateString);
  //     if (isNaN(date)) return "N/A";
  //     return new Intl.DateTimeFormat("en-GB", {
  //       day: "2-digit",
  //       month: "short",
  //       year: "numeric"
  //     }).format(date);
  //   };

  const columns = [
    {field: "id", headerName: "#", width: 50, headerAlign: "center", align: "center"},
    {field: "empId", headerName: "EMP ID", width: 70, headerAlign: "left", align: "left"},
    {
      field: "employeeName",
      headerName: "Employee Name",
      width: 150,
      headerAlign: "left",
      align: "left"
    },
    {
      field: "reportingFrom",
      headerName: "Reporting From",
      width: 130,
      headerAlign: "left",
      align: "left",
      renderCell: params => formatDate(params.value) || "N/A"
    },
    {
      field: "designation",
      headerName: "Designation",
      width: 200,
      headerAlign: "left",
      align: "left"
    },
    {
      field: "joinDate",
      headerName: "Date of Joining",
      width: 120,
      headerAlign: "left",
      align: "left",
      renderCell: params => formatDate(params.value) || "N/A"
    },
    {
      field: "plannedLeaves",
      headerName: "PL",
      width: 70,
      headerAlign: "center",
      align: "center"
    },
    {
      field: "unplannedLeaves",
      headerName: "UPL",
      width: 70,
      headerAlign: "center",
      align: "center"
    },
    {
      field: "coffLeaves",
      headerName: "COFF",
      width: 70,
      headerAlign: "center",
      align: "center"
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      headerAlign: "center",
      align: "center",
      renderCell: params => [
        <Tooltip title="Assign Project" key={`assign-${params.row.empId}`}>
          <AssignmentIcon
            color="primary"
            sx={{
              cursor: "pointer",
              fontSize: "1.3rem",
              transform: "scale(1.3)"
            }}
            onClick={handleAssignProject(params.row.empId)}
          />
        </Tooltip>
      ]
    }
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={2}>
        <AppBar position="static">
          <Card>
            <MDBox pt={2} pb={2} px={3}>
              <MDTypography variant="h6" color="textPrimary" fontFamily={properties.fontFamily}>
                Reporting Employee List
              </MDTypography>
            </MDBox>
            <MDBox pb={2} px={1} sx={{height: "600px", overflow: "auto"}}>
              <DataGrid
                rows={data}
                columns={columns}
                rowModesModel={rowModesModel}
                getRowId={row => row.empId}
                loading={loading}
                paginationMode="server"
                rowCount={totalRows}
                pageSizeOptions={[20]}
                paginationModel={paginationModel}
                onPaginationModelChange={handlePaginationChange}
                sx={{
                  fontFamily: properties.fontFamily,
                  fontSize: "14px",
                  "& .MuiDataGrid-columnHeaders": {
                    position: "sticky",
                    top: 0,
                    backgroundColor: "white",
                    zIndex: 1000
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    overflow: "auto"
                  },
                  "& .MuiDataGrid-root": {
                    height: "auto",
                    maxHeight: "600px"
                  }
                }}
              />
            </MDBox>
            <Snackbar
              open={snackOpen}
              anchorOrigin={{vertical: "top", horizontal: "right"}}
              autoHideDuration={6000}
              onClose={handleClose}
            >
              <Alert
                onClose={handleClose}
                severity={snackColor}
                variant="filled"
                sx={{width: "100%", color: "#fff"}}
              >
                {snackMessage}
              </Alert>
            </Snackbar>
          </Card>
        </AppBar>
      </MDBox>
    </DashboardLayout>
  );
}
